import React from "react";
import "./Chris_Sheppard.css";



const Chris_Sheppard = () => (

  <div className='Chris_Sheppard'>

  <a href={"https://www.linkedin.com/in/clsheppard/"} target={"_blank"}><h3 className="text-center" >Chris Sheppard</h3></a>
 
<p className='RecP' >Charles and I were part of the initial launch of a 
home automation and security system named SAGE. Charles was on the short 
list of people with whom I would confer. He always made time for others, 
thereby amplifying the value of those around him. He'd look over my source. 
He helped me sort through unfamiliar portions of the SAGE project. We'd 
share the joy of good trivia and bad jokes. Charles is bright, hard working 
and humble. I would happily work with him again.</p>

  </div>
);

export default Chris_Sheppard;


// WEBPACK FOOTER //
// ./src/components/AboutMe/Chris_Sheppard.js